import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

// IInlineStyles'i genişletmek için kendi stil nesnenizi oluşturun
interface ICustomInlineStyles {
  bold?: () => string;
  italic?: () => string;
  underline?: () => string;
  strike?: () => string;
  color?: (value: string) => string;
  background?: (value: string) => string;
  font?: (value: string) => string;
  size?: (value: string) => string;
  align?: (value: string) => string;
  header?: (value: number) => string;
}

interface DeltaOperation {
  insert: string;
  attributes?: {
    [key: string]: any;
  };
}

interface Delta {
  ops: DeltaOperation[];
}

export const deltaToHTML = (delta: Delta): string => {
  const converter = new QuillDeltaToHtmlConverter(delta.ops, {
    customCssClasses: (op) => {
      let classes: string[] = [];
      
      // Text alignment
      if (op.attributes && op.attributes.align) {
        classes.push(`ql-align-${op.attributes.align}`);
      }
      
      // List formatting
      if (op.attributes && op.attributes.list) {
        classes.push(`ql-list-${op.attributes.list}`);
      }
      
      // Blockquote styling
      if (op.attributes && op.attributes.blockquote) {
        classes.push("ql-blockquote");
      }
      
      // Code block styling
      if (op.attributes && op.attributes.code) {
        classes.push("ql-code");
      }

      return classes.join(" ");
    },
    inlineStyles: {
      bold: () => "font-weight: bold;",
      italic: () => "font-style: italic;",
      underline: () => "text-decoration: underline;",
      strike: () => "text-decoration: line-through;",
      
      // Handling colors
      color: (value: string) => `color: ${value};`,
      background: (value: string) => `background-color: ${value};`,
      
      // Handling fonts
      font: (value: string) => `font-family: ${value};`,
      
      // Handling font size
      size: (value: string) => {
        const sizeMap: Record<string, string> = {
          small: "12px",
          normal: "16px",
          large: "24px",
          huge: "32px",
        };
        return `font-size: ${sizeMap[value] || value};`;
      },
      
      // Align text based on Quill's attributes
      align: (value: string) => {
        if (value === "center") return "text-align: center;";
        if (value === "right") return "text-align: right;";
        if (value === "justify") return "text-align: justify;";
        return "text-align: left;";
      },

      // Handling header (h1, h2, h3, etc.)
      header: (value: number) => {
        if (value === 1) return "font-size: 2em; font-weight: bold;";
        if (value === 2) return "font-size: 1.5em; font-weight: bold;";
        if (value === 3) return "font-size: 1.17em; font-weight: bold;";
        return "font-size: 1em;";
      },
    } as ICustomInlineStyles, // Tip genişlemesi burada yapılır
  });

  return converter.convert();
};
